import { render } from "./DownloadMpQrcode.vue?vue&type=template&id=2d15679c&ts=true"
import script from "./DownloadMpQrcode.vue?vue&type=script&lang=ts"
export * from "./DownloadMpQrcode.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__